import { ssoClient } from "./client";

const GetAppList=()=>{
  return ssoClient
      .get('Application/Dashboard');
}

const aplicationApi = { GetAppList}
export default aplicationApi;
